import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import NotFound from './pages/Page404';
import Forgot from './pages/Forgot';
import ChangePassword from './pages/ChangePassword';
import OtpVerification from './pages/OtpVerification';
import EditProfile from './pages/EditProfile';
import Help from './pages/Help';
import Settings from './pages/Settings';
import Home from './pages/Services/Home';
import SubServices from './pages/Services/SubServices';
import CustomerList from './pages/Services/CustomerList';
import AddCustomer from './pages/Services/AddCustomer';
import AddSteps from './pages/Services/AddSteps';
import Tracking from './pages/Services/Tracking';
import Message from './pages/Services/Message';
import History from './pages/History/History';
import Document from './pages/Services/Document';
import Share from './pages/Share';
import HistoryMessage from './pages/History/HistoryMessage';
import HistoryDoc from './pages/History/HistoryDoc';
import Map from './pages/Services/Map';

export default function Router() {
  const localPerm = JSON.parse(localStorage.getItem('permissions'));
  const token = localStorage.getItem('token');

  return useRoutes([
    {
      path: '/',
      element: token ? <Navigate to="/dashboard/services" /> : <LogoOnlyLayout />,
      children: [
        { path: 'app', element: <Navigate to="/dashboard/services" /> },
        { path: '/', element: <Navigate to="/login" /> },
        { path: 'login', element: <Login /> },
        { path: 'signup', element: <Register /> },
        { path: 'forgot', element: <Forgot /> },
        { path: 'changePassword', element: <ChangePassword /> },
        { path: 'otpVerification', element: <OtpVerification /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/dashboard/404" /> },
        {
          path: 'app',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'dashboard')?.length >
            0 ? (
              <Home />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'edit_profile',
          element: <EditProfile />
        },
        {
          path: 'services',
          element: <Home />
        },
        {
          path: 'services/sub_services',
          element: <SubServices />
        },
        {
          path: 'services/sub_services/customer_list',
          element: <CustomerList />
        },
        {
          path: 'services/sub_services/customer_list/tracking',
          element: <Tracking />
        },
        {
          path: 'services/sub_services/customer_list/map',
          element: <Map />
        },
        {
          path: 'services/sub_services/customer_list/message',
          element: <Message />
        },
        {
          path: 'services/sub_services/customer_list/Document',
          element: <Document />
        },
        {
          path: 'services/sub_services/customer_list/add_customers',
          element: <AddCustomer />
        },
        {
          path: 'services/sub_services/add_steps',
          element: <AddSteps />
        },

        {
          path: 'helps',
          element: <Help />
        },
        {
          path: 'share',
          element: <Share />
        },
        {
          path: 'settings',
          element: <Settings />
        },
        {
          path: 'history',
          element: <History />
        },
        {
          path: '/dashboard/history/historymessage',
          element: <HistoryMessage />
        },
        {
          path: '/dashboard/history/historydoc',
          element: <HistoryDoc />
        }
      ]
    },

    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
